import { request } from '@tencent/ppd-base-libs';

type TNCConfig = {
  type: string;
  tncId: string;
  title: string;
  content: string;
};

export async function getTNCConfigByType(type: string): Promise<TNCConfig[]> {
  return await request.loadVtools(`https://st.moneydata.hk/wuji/config/tncCfg/${type}.json`);
}

